module.exports = __webpack_public_path__ + "img/ntts-logo.3e364488.png";